import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { Network, SnoozeAndWarranty, SystemInfo, ThresholdSettings } from "modules/DealerOverviewDashboard/components/DmsSystem/components";

type DmsSystemProps = {
  tabId: string;
};

export const DmsSystem = ({ tabId }: DmsSystemProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="dealer-overview-section">
      <div className="section-title">
        <div>
          <Icon className="cloud" />
        </div>
        <span className="section-title-text">{t("v8_dms_system", "DMS / System")}</span>
      </div>
      <SystemInfo />
      <Network />
      <ThresholdSettings />
      <SnoozeAndWarranty />
    </Element>
  );
};
